export const TABLE_BORDER_RADIUS = 8;